import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[cowtuxWidgetToggle]'
})
export class COWTUXWidgetToggleDirective
{
    /**
     * Constructor
     *
     * @param {ElementRef} elementRef
     */
    constructor(
        public elementRef: ElementRef
    )
    {
    }
}
